// extracted by mini-css-extract-plugin
var _1 = "SectionStyle-module__section___y1V0l";
export { _1 as "section" }
